import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app';
import '@/styles/index.css';

const rootElement = document.querySelector('#root');

if (!rootElement) {
  throw new Error('Analytics root element was not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
